
import Vue from "vue";
import Component from "vue-class-component";
import InputForm from "@/components/base/form/InputForm.vue";
import { Getter, State, Action } from "vuex-class";
import { FormConfig, FormValid } from "@/config";
@Component({
	name: "Calculate",
	components: { InputForm }
})
export default class Calculate extends Vue {
	type: any = this.$route.query.type;
	// @State("basic") private basic: any;
	// @Getter("id") private id: any;
	@Getter("role") private role: any;
	// @Getter("phone") private phone: any;
	// @Getter("account") private account: any;
	// isAuthern: number = 0;
	// @Action("account/getPersonAuthernList") private getPersonAuthernList: any;
	// @Action("account/getBasic") private getBasic: any;
	// @Action("account/addBasic") private addBasic: any;
	isEdit = false;
	formName: any = "CompanyBaseInfo";
	currentPage = 0;
	labelWidth: any = "240px";
	labelPosition: any = "left";
	// 状态
	state = 0;
	step: number = 1;
	btnData = "基本信息";
	input = "";
	rules_size: any = {
		industry: [
			{
				required: true,
				message: "请输入行业",
				trigger: "blur"
			}
		],
		last_year_total_income: [
			{
				required: true,
				message: "请输入上年度总收入(万元)",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		last_two_year_main_income: [
			{
				required: true,
				message: "请输入近2个会计年度主营业务收入(万元)",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		last_two_year_RD_income: [
			{
				required: true,
				message: "请输入近2个会计年度研究开发费用总额(万元)",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		last_year_service_income: [
			{
				required: true,
				message: "请输入上年度技术产品(服务)收入(万元)",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		tech_amount: [
			{
				required: true,
				message: "请输入从业人员人数",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		junior_tech_amount: [
			{
				required: true,
				message: "请输入具有大专以上学历的科技人员人数",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		invent_patent_amount: [
			{
				required: true,
				message: "请输入企业已获取的发明专利",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		RD_amount: [
			{
				required: true,
				message: "请输入从事研究开发的科技人员人数",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		tradeMark_amount: [
			{
				required: true,
				message: "请输入企业已获取的商标",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		drup_amount: [
			{
				required: true,
				message: "请输入企业已获取的新药证书",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		species_amount: [
			{
				required: true,
				message: "请输入企业已获取的动植物新品种",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		integrated_circuit_amount: [
			{
				required: true,
				message: "请输入企业已获取的集成电路布图设计",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		copyright_amount: [
			{
				required: true,
				message: "请输入企业已获取的软件著作权",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		tech_payoff_amount: [
			{
				required: true,
				message: "请输入企业已获取的经认定的科技成果",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		tech_other_amount: [
			{
				required: true,
				message: "请输入企业已获取的其他专有技术",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		creditRecord: [
			{
				required: true,
				message: "请选择信用记录",
				trigger: "blur"
			}
		]
	};
	// 中小微企业评估
	formData_size: any = {};
	setting_size: any = [
		{
			label: "行业选择",
			ref: "industry",
			type: "cascader",
			options: FormConfig.industry2,
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "上年度总收入(万元)",
			ref: "last_year_total_income",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "近2个会计年度主营业务收入(万元)",
			ref: "last_two_year_main_income",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "近2个会计年度研究开发费用总额(万元)",
			ref: "last_two_year_RD_income",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "上年度技术产品(服务)收入(万元)",
			ref: "last_year_service_income",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "从业人员人数",
			ref: "tech_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "具有大专以上学历的科技人员人数",
			ref: "junior_tech_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "从事研究开发的科技人员人数",
			ref: "RD_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "企业已获取的发明专利",
			ref: "invent_patent_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "企业已获取的商标",
			ref: "tradeMark_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "企业已获取的新药证书",
			ref: "drup_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "企业已获取的动植物新品种",
			ref: "species_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "企业已获取的集成电路布图设计",
			ref: "integrated_circuit_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "企业已获取的软件著作权",
			ref: "copyright_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "企业已获取的经认定的科技成果",
			ref: "tech_payoff_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "企业已获取的其他专有技术",
			ref: "tech_other_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "信用记录",
			ref: "creditRecord",
			type: "cascader",
			options: [
				{
					value: "优秀",
					label: "优秀"
				},
				{
					value: "良好",
					label: "良好"
				},
				{
					value: "不良",
					label: "不良"
				}
			],
			span: 12,
			disabled: false,
			required: false,
			index: 1
		}
	];
	// 国高新企业认定1
	rules_high: any = {
		registTime: [
			{
				required: true,
				message: "请选择企业申请认定时间注册成立时间",
				trigger: "blur"
			}
		],
		invention_patent_amount: [
			{
				required: true,
				message: "请输入发明专利(含国防专利)数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		plant_amount: [
			{
				required: true,
				message: "请输入植物新品种数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		country_plant_amount: [
			{
				required: true,
				message: "请输入植物新品种数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		protect_plant_amount: [
			{
				required: true,
				message: "请输入国家-级中药保护品种数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		yield_plant_amount: [
			{
				required: true,
				message: "请输入国家级农作物新品种数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		drup_amount: [
			{
				required: true,
				message: "请输入企业已获取的新药证书数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		layout_amount: [
			{
				required: true,
				message: "请输入集成电路布图设计专有权数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		new_amount: [
			{
				required: true,
				message: "请输入实用新型专利数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		design_amount: [
			{
				required: true,
				message: "请输入外观设计专利数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		copyright_amount: [
			{
				required: true,
				message: "请输入软件著作权(不含商标)数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		staff_amount: [
			{
				required: true,
				message: "请输入入员工数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		pro_staff_amount: [
			{
				required: true,
				message: "请输入专业入员工数量",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		last_three_sold: [
			{
				required: true,
				message: "请输入近三年销售额",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		last_one_sold: [
			{
				required: true,
				message: "请输入近一年销售额",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		last_three_dev: [
			{
				required: true,
				message: "请输入近三年研发额",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		high_tech_income: [
			{
				required: true,
				message: "请输入近一年高新技术产品(服务)收入",
				trigger: "blur"
			},
			{ validator: FormValid.number }
		],
		is_break: [
			{
				required: true,
				message: "请输入是否安全违规",
				trigger: "blur"
			}
		]
	};
	rules_high2: any = {
		tech_transform: [
			{
				required: true,
				message: "请选择科技成果的转化能力",
				trigger: "blur"
			}
		],
		is_develop: [
			{
				required: true,
				message:
					"请选择是否建立了科技人员的培养进修、职工技能培训、优秀人才引进,以及人才绩效评价奖励制度",
				trigger: "blur"
			}
		],
		is_create: [
			{
				required: true,
				message:
					"请选择是否建立了科技成果转化的组织实施与激励奖励制度,建立开放式的创新创业平台",
				trigger: "blur"
			}
		],
		is_tech: [
			{
				required: true,
				message:
					"请选择是否设立了内部科学技术研究开发机构并具备相应的科研条件，与国内外开发机构开展多种形式产学研合作",
				trigger: "blur"
			}
		],
		is_join: [
			{
				required: true,
				message: "请选择是否参与制标",
				trigger: "blur"
			}
		],
		copyright_way: [
			{
				required: true,
				message: "请选择知识产权的获得方式",
				trigger: "blur"
			}
		],
		advance: [
			{
				required: true,
				message: "请选择企业知识产权的先进程度",
				trigger: "blur"
			}
		],
		core_important: [
			{
				required: true,
				message: "请选择企业知识产权核心作用",
				trigger: "blur"
			}
		],
		copyright_amount: [
			{
				required: true,
				message: "请选择知识产权数量",
				trigger: "blur"
			}
		],
		first_net: [
			{
				required: true,
				message: "请输入第一年末净资产",
				trigger: "blur"
			}
		],
		second_net: [
			{
				required: true,
				message: "请输入第二年末净资产",
				trigger: "blur"
			}
		],
		third_net: [
			{
				required: true,
				message: "请输入第三年末净资产",
				trigger: "blur"
			}
		],
		first_sold: [
			{
				required: true,
				message: "请输入第一年末销售收入",
				trigger: "blur"
			}
		],
		second_sold: [
			{
				required: true,
				message: "请输入第二年末销售收入",
				trigger: "blur"
			}
		],
		third_sold: [
			{
				required: true,
				message: "请输入第三年末销售收入",
				trigger: "blur"
			}
		]
	};
	setting_high2: any = [
		{
			label: "科技成果的转化能力",
			ref: "tech_transform",
			type: "radio",
			options: [
				{
					value: "30",
					label: "转化能力强,》5项"
				},
				{
					value: "24",
					label: "转化能力较强,》4项"
				},
				{
					value: "18",
					label: "转化能力一般,》3项"
				},
				{
					value: "12",
					label: "转化能力较弱,》2项"
				},
				{
					value: "6",
					label: "转化能力弱,》1项"
				},
				{
					value: "0",
					label: "转化能力无,》0项"
				}
			],
			span: 24,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label:
				"是否建立了科技人员的培养进修、职工技能培训、优秀人才引进,以及人才绩效评价奖励制度",
			ref: "is_develop",
			type: "radio",
			options: [
				{
					value: "4",
					label: "是"
				},
				{
					value: "0",
					label: "否"
				}
			],
			span: 24,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label:
				"是否建立了科技成果转化的组织实施与激励奖励制度,建立开放式的创新创业平台",
			ref: "is_create",
			type: "radio",
			options: [
				{
					value: "4",
					label: "是"
				},
				{
					value: "0",
					label: "否"
				}
			],
			span: 24,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label:
				"是否设立了内部科学技术研究开发机构并具备相应的科研条件，与国内外开发机构开展多种形式产学研合作",
			ref: "is_tech",
			type: "radio",
			options: [
				{
					value: "6",
					label: "是"
				},
				{
					value: "0",
					label: "否"
				}
			],
			span: 24,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label:
				"是否制定了企业研究开发的组织管理制度,建立了研究投入核算体系,编制了研发费用辅助帐",
			ref: "is_makeRule",
			type: "radio",
			options: [
				{
					value: "6",
					label: "是"
				},
				{
					value: "0",
					label: "否"
				}
			],
			span: 24,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "是否参与制标",
			ref: "is_join",
			type: "radio",
			options: [
				{
					value: "2",
					label: "是"
				},
				{
					value: "0",
					label: "否"
				}
			],
			span: 24,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "知识产权的获得方式",
			ref: "copyright_way",
			type: "radio",
			options: [
				{
					value: "6",
					label: "有自主研发"
				},
				{
					value: "3",
					label: "仅有受让、受赠和并购等"
				}
			],
			span: 24,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "企业知识产权的先进程度",
			ref: "advance",
			type: "radio",
			options: [
				{
					label: "高",
					value: "8"
				},
				{
					label: "较高",
					value: "6"
				},
				{
					label: "一般",
					value: "4"
				},
				{
					label: "较低",
					value: "2"
				},
				{
					label: "无",
					value: "0"
				}
			],
			span: 24,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "企业知识产权核心作用",
			ref: "core_important",
			type: "radio",
			options: [
				{
					value: "8",
					label: "高"
				},
				{
					value: "6",
					label: "较高"
				},
				{
					value: "4",
					label: "一般"
				},
				{
					value: "2",
					label: "较低"
				},
				{
					value: "0",
					label: "无"
				}
			],
			span: 24,
			disabled: false,
			required: false
		},
		{
			label: "知识产权数量",
			ref: "copyright_amount",
			type: "radio",
			options: [
				{
					value: "8",
					label: "1项及以上(I类)"
				},
				{
					value: "6",
					label: "5项及以上(II类)"
				},
				{
					value: "4",
					label: "3-4项(II类)"
				},
				{
					value: "2",
					label: "1-2项(II类)"
				},
				{
					value: "0",
					label: "0项目"
				}
			],
			span: 24,
			disabled: false,
			required: false
		},
		{
			label: "净资产(万元)",
			type: "item",
			span: 24,
			style: "box"
		},
		{
			label: "第一年末",
			ref: "first_net",
			placeholder: "净资产(万元)",
			type: "input",
			style: "triangle",
			disabled: false,
			required: false
		},
		{
			label: "第二年末",
			ref: "second_net",
			placeholder: "净资产(万元)",
			type: "input",
			style: "triangle",
			disabled: false,
			required: false
		},
		{
			label: "第三年末",
			ref: "third_net",
			placeholder: "净资产(万元)",
			type: "input",
			style: "triangle",
			disabled: false,
			required: false
		},
		{
			label: "销售收入(万元)",
			type: "item",
			span: 24,
			style: "box"
		},
		{
			label: "第一年末",
			ref: "first_sold",
			placeholder: "销售收入(万元)",
			type: "input",
			style: "triangle",
			disabled: false,
			required: false
		},
		{
			label: "第二年末",
			ref: "second_sold",
			placeholder: "销售收入(万元)",
			type: "input",
			style: "triangle",
			disabled: false,
			required: false
		},
		{
			label: "第三年末",
			ref: "third_sold",
			placeholder: "销售收入(万元)",
			type: "input",
			style: "triangle",
			disabled: false,
			required: false
		}
	];
	formData_high2: any = {};
	formData_high: any = {
		registTime: "",
		invention_patent_amount: "",
		plant_amount: "",
		protect_plant_amount: "",
		yield_plant_amount: "",
		drup_amount: "",
		layout_amount: "",
		new_amount: "",
		design_amount: "",
		copyright_amount: "",
		staff_amount: "",
		pro_staff_amount: "",
		last_three_sold: "",
		last_one_sold: "",
		last_three_dev: "",
		high_tech_income: "",
		is_break: ""
	};
	setting_high: any = [
		{
			label: "企业申请认定时间注册成立时间",
			ref: "registTime",
			type: "radio",
			options: [
				{
					value: "注册成立不足一年",
					label: "注册成立不足一年"
				},
				{
					value: "注册成立一年以上",
					label: "注册成立一年以上"
				}
			],
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "发明专利(含国防专利)",
			ref: "invention_patent_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "植物新品种",
			ref: "plant_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "国家级农作物新品种",
			ref: "yield_plant_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "国家新药",
			ref: "drup_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "国家-级中药保护品种",
			ref: "protect_plant_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "集成电路布图设计专有权",
			ref: "layout_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "实用新型专利",
			ref: "new_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "外观设计专利",
			ref: "design_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "软件著作权(不含商标)",
			ref: "copyright_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "员工数量",
			ref: "staff_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "专业研发人员(本科以上)",
			ref: "pro_staff_amount",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "近三年销售额",
			ref: "last_three_sold",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "近一年销售额",
			ref: "last_one_sold",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "近三年研发额",
			ref: "last_three_dev",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "高新技术产品(服务)收入",
			ref: "high_tech_income",
			type: "input",
			span: 12,
			disabled: false,
			required: false,
			index: 1
		},
		{
			label: "是否安全违规",
			ref: "is_break",
			type: "radio",
			options: [
				{
					value: "最近一年收到处罚",
					label: "最近一年收到处罚"
				},
				{
					value: "最近一年未被处罚",
					label: "最近一年未被处罚"
				}
			],
			span: 12,
			disabled: false,
			required: false,
			index: 1
		}
	];
	request: string = "";
	async nextStepHight() {
		const state = await (this.$refs.ref_calculate as any).validFormReturn();
		if (!state) {
			return this.$message.warning("请完整的填写表单!");
		}
		const {
			registTime,
			copyright_amount,
			design_amount,
			new_amount,
			layout_amount,
			protect_plant_amount,
			drup_amount,
			yield_plant_amount,
			plant_amount,
			invention_patent_amount,
			is_break,
			last_one_sold,
			high_tech_income,
			last_three_dev,
			last_three_sold,
			pro_staff_amount,
			staff_amount
		} = this.formData_high;

		// 企业研发人员占比
		const RD_rate = pro_staff_amount / staff_amount;
		if (RD_rate < 0.1) {
			return (this.request = "很遗憾您不满足国家高新技术企业评测的基本条件");
		}
		// 近三年研发额占比
		const sale_rate = last_three_dev / last_three_sold;
		if (sale_rate < 0.03) {
			return (this.request = "很遗憾您不满足国家高新技术企业评测的基本条件");
		}
		// 近一年研发额占比
		const one_rate = high_tech_income / last_one_sold;
		if (one_rate < 0.6) {
			return (this.request = "很遗憾您不满足国家高新技术企业评测的基本条件");
		}
		if (is_break.includes("最近一年收到处罚")) {
			return (this.request = "很遗憾您不满足国家高新技术企业评测的基本条件");
		}
		const all_copyright =
			invention_patent_amount +
			plant_amount +
			yield_plant_amount +
			drup_amount +
			protect_plant_amount +
			layout_amount +
			new_amount +
			design_amount +
			copyright_amount;
		if (all_copyright <= 0) {
			return (this.request = "很遗憾您不满足国家高新技术企业评测的基本条件");
		}
		if (registTime.includes("注册成立不足一年")) {
			return (this.request = "很遗憾您不满足国家高新技术企业评测的基本条件");
		}
		this.$confirm("是否进行企业创新能力评测?", "提示", {
			confirmButtonText: "确定",
			cancelButtonText: "取消",
			type: "warning"
		})
			.then(() => {
				this.step = 2;
				(document.getElementById("main") as any).scrollTop = 0;
			})
			.catch(() => {
				(document.getElementById("main") as any).scrollTop = 0;
			});
	}
	async nextStepHight2() {
		const state = await (this.$refs.ref_calculate as any).validFormReturn();
		if (!state) {
			return this.$message.warning("请完整的填写表单!");
		}
		const {
			advance,
			core_important,
			copyright_amount,
			copyright_way,
			is_join,
			tech_transform,
			is_makeRule,
			is_tech,
			is_create,
			is_develop,
			first_net,
			second_net,
			third_net,
			first_sold,
			second_sold,
			third_sold
		} = this.formData_high2;
		if (
			first_net == 0 ||
			second_net == 0 ||
			third_net == 0 ||
			first_sold == 0 ||
			second_sold == 0 ||
			third_sold == 0
		) {
			this.request = "很遗憾您未能满足企业创新能力评测的要求";
			return this.$message.success(this.request);
		}
		let netAddedRatio =
			(1 / 2) * (second_net / first_net + third_net / second_net) - 1;
		let soldAddedRatio =
			(1 / 2) * (second_sold / first_sold + third_sold / second_sold) - 1;
		let netScore = 0;
		if (netAddedRatio > 0.35) {
			netScore = 9;
		} else if (netAddedRatio > 0.25) {
			netScore = 7;
		} else if (netAddedRatio > 0.15) {
			netScore = 5;
		} else if (netAddedRatio > 0.05) {
			netScore = 3;
		} else if (netAddedRatio > 0) {
			netScore = 1;
		} else {
			netScore = 0;
		}
		let score =
			Number(advance[0]) +
			Number(core_important[0]) +
			Number(copyright_amount[0]) +
			Number(copyright_way[0]) +
			Number(is_join[0]) +
			Number(tech_transform[0]) +
			Number(is_makeRule[0]) +
			Number(is_tech[0]) +
			Number(is_create[0]) +
			Number(is_develop[0]) +
			Number(netScore);
		if (score < 70) {
			this.request = "很遗憾您未能满足企业创新能力评测的要求";
		} else {
			this.request =
				"您已经满足国家高新技术企业评测的要求,请携带相关资料进行申请";
		}
		this.$message.success(this.request);
	}
	backStep() {
		this.toMatch();
	}
	toMatch(res?: any) {
		let role = "";
		switch (this.role) {
			case "person":
				role = "Person";
				break;
			case "unit":
				role = "Unit";
				break;
			case "declare":
				role = "Apply";
				break;
		}
		this.$router.push({
			name: `${role}Match`
		});
	}
	async nextStepSize() {
		const state = await (this.$refs.ref_calculate as any).validFormReturn();
		if (!state) {
			return this.$message.warning("请完整的填写表单!");
		}
		// 判断公司大小
		const {
			industry,
			last_year_total_income,
			tech_amount
		} = this.formData_size;
		// 3-大|2-中|1-小|0-微
		let type: any = "";
		switch (industry[0]) {
			case "农、林、牧、渔业":
				{
					if (last_year_total_income >= 20000) {
						type = 3;
					} else if (last_year_total_income >= 500) {
						type = 2;
					} else if (last_year_total_income >= 50) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "工业":
				{
					if (last_year_total_income >= 40000 && tech_amount >= 1000) {
						type = 3;
					} else if (last_year_total_income >= 2000 && tech_amount >= 300) {
						type = 2;
					} else if (last_year_total_income >= 300 && tech_amount >= 20) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "建筑业":
				{
					// tech_amount需要切换成资产总额
					if (last_year_total_income >= 80000 && tech_amount >= 80000) {
						type = 3;
					} else if (last_year_total_income >= 6000 && tech_amount >= 5000) {
						type = 2;
					} else if (last_year_total_income >= 300 && tech_amount >= 300) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "批发业":
				{
					if (last_year_total_income >= 40000 && tech_amount >= 200) {
						type = 3;
					} else if (last_year_total_income >= 5000 && tech_amount >= 20) {
						type = 2;
					} else if (last_year_total_income >= 1000 && tech_amount >= 5) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "零售页":
				{
					if (last_year_total_income >= 20000 && tech_amount >= 300) {
						type = 3;
					} else if (last_year_total_income >= 500 && tech_amount >= 50) {
						type = 2;
					} else if (last_year_total_income >= 100 && tech_amount >= 10) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "交通运输业":
				{
					if (last_year_total_income >= 30000 && tech_amount >= 1000) {
						type = 3;
					} else if (last_year_total_income >= 3000 && tech_amount >= 300) {
						type = 2;
					} else if (last_year_total_income >= 200 && tech_amount >= 20) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "仓储业":
				{
					if (last_year_total_income >= 30000 && tech_amount >= 200) {
						type = 3;
					} else if (last_year_total_income >= 1000 && tech_amount >= 100) {
						type = 2;
					} else if (last_year_total_income >= 100 && tech_amount >= 20) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "邮政业":
				{
					if (last_year_total_income >= 30000 && tech_amount >= 1000) {
						type = 3;
					} else if (last_year_total_income >= 2000 && tech_amount >= 300) {
						type = 2;
					} else if (last_year_total_income >= 100 && tech_amount >= 20) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "住宿业":
				{
					if (last_year_total_income >= 10000 && tech_amount >= 300) {
						type = 3;
					} else if (last_year_total_income >= 2000 && tech_amount >= 100) {
						type = 2;
					} else if (last_year_total_income >= 100 && tech_amount >= 10) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "餐饮业":
				{
					if (last_year_total_income >= 10000 && tech_amount >= 300) {
						type = 3;
					} else if (last_year_total_income >= 2000 && tech_amount >= 100) {
						type = 2;
					} else if (last_year_total_income >= 100 && tech_amount >= 10) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "信息传输业":
				{
					if (last_year_total_income >= 100000 && tech_amount >= 2000) {
						type = 3;
					} else if (last_year_total_income >= 1000 && tech_amount >= 100) {
						type = 2;
					} else if (last_year_total_income >= 100 && tech_amount >= 10) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "软件和信息服务业":
				{
					if (last_year_total_income >= 10000 && tech_amount >= 300) {
						type = 3;
					} else if (last_year_total_income >= 1000 && tech_amount >= 100) {
						type = 2;
					} else if (last_year_total_income >= 50 && tech_amount >= 10) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "房地产开发经营":
				{
					// tech_amount替换成资产总额
					if (last_year_total_income >= 200000) {
						type = 3;
					} else if (last_year_total_income >= 1000) {
						type = 2;
					} else if (last_year_total_income >= 100) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "物业管理":
				{
					if (last_year_total_income >= 5000 && tech_amount >= 1000) {
						type = 3;
					} else if (last_year_total_income >= 1000 && tech_amount >= 300) {
						type = 2;
					} else if (last_year_total_income >= 500 && tech_amount >= 100) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			case "租凭和商务服务业":
				{
					if (tech_amount >= 300) {
						type = 3;
					} else if (tech_amount >= 100) {
						type = 2;
					} else if (tech_amount >= 10) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
			default:
				{
					if (tech_amount >= 300) {
						type = 3;
					} else if (tech_amount >= 100) {
						type = 2;
					} else if (tech_amount >= 10) {
						type = 1;
					} else {
						type = 0;
					}
				}
				break;
		}
		this.request = `成功评定当前企业为${
			type === 3 ? "大" : type === 2 ? "中" : type === 1 ? "小" : "微"
		}型企业`;
		this.$message.success(this.request);
		// this.$message.success("成功评定您的")
	}
	nextStep() {
		(document.getElementById("main") as any).scrollTop = 0;
		if (this.type == 0) {
			if (this.step == 1) {
				this.nextStepHight();
			} else {
				this.nextStepHight2();
			}
		} else {
			this.nextStepSize();
		}
	}
}
